module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_11.e0f6b359.png";